import { render, staticRenderFns } from "./EmployerAvatar.vue?vue&type=template&id=0274d800&scoped=true"
import script from "./EmployerAvatar.vue?vue&type=script&lang=js"
export * from "./EmployerAvatar.vue?vue&type=script&lang=js"
import style0 from "./EmployerAvatar.vue?vue&type=style&index=0&id=0274d800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0274d800",
  null
  
)

export default component.exports